import react, { useState, useEffect } from "react";
import {Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography,
IconButton, Container} from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import DeleteIcon from "@mui/icons-material/Delete";
import { ReadableDateTime } from "../utils/momentUtils";
import { ConfirmDialog } from "./ConfirmDialog";





export const SolutionList = (props) => {
  const {solutions, onItemClick, onDelete} = props;
  const [toDel, setToDel] = useState(null);
  const [open, setOpen] = useState(false);

  const handleConfirm = async () => {
    if (toDel){
      setOpen(false);
      await onDelete(toDel);
      setToDel(null);
    }else{ 
      setOpen(false);
    }
  }

  const HandleDeleteClick = (solution) => {
    setToDel(solution);
    setOpen(true);
  }

  const getSolutionString = (solution, sepChar=',') => {
    let retString = "";
    console.log(solution);
    if (solution.metrics && Array.isArray(solution.metrics) && solution.metrics.length > 0){
      for (const idx in solution.metrics){
        let metric = solution.metrics[idx];
        let currString = `${metric.label}: ${metric.value}${sepChar} `;
        retString = retString.concat(currString);
      }
      retString = retString.slice(0, -2);
    }
    return retString;
  }

  return (
    <>
        <List>
            {solutions?.map(sol => {
              return (
              <ListItem key={sol.id} secondaryAction={ onDelete ?
                <IconButton edge="end" aria-label="delete" onClick={() => HandleDeleteClick(sol)}>
                  <DeleteIcon />
                </IconButton> : <></>
              }>
                <ListItemButton onClick={() => onItemClick(sol)}>
                  <ListItemIcon>
                    <CategoryIcon/>
                  </ListItemIcon>
                  <ListItemText primary={sol.name} secondary={getSolutionString(sol, '\n')} secondaryTypographyProps={{whiteSpace: 'pre-line'}}/>
                </ListItemButton>
              </ListItem>
              ) 
          })}
          </List>
        <ConfirmDialog 
          titleText="Delete Schedule?" 
          open={open}
          handleClose={() => setOpen(false)}
          handleCancel={() => {
            setToDel(null);
            setOpen(false);
          }}
          handleConfirm={handleConfirm}
        >
          Are you sure you'd like to delete schedule {toDel ? toDel.name : ""}? <br/>
          You cannot undo this action once completed. 
        </ConfirmDialog>
    </>
  )
}

export default SolutionList